import { Component, Input } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
@Component({
  selector: 'onboarding-content',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent {
    public title : string = "";
    public content : string = "";

    constructor(
        public onboardingModal: BsModalRef
    ) {  }
}


// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/main/onboarding/onboarding.component.ts